<div class="pagination row">
    <button [class.disabled]="currentPage === 1"  (click)="onPrevious()"  type="button" class="btn row"><span
            class="material-symbols-outlined">
            keyboard_arrow_left
        </span></button>
    <div class="row row_ai_center fw_400 fz_m pagination_item"><input type="number" min="1" [max]='totalPages' name="number" class="inp inp_numeric" (input)="onPageChange($event)" [value]="currentPage">/ {{ totalPages }}</div>
    <button [class.disabled]="currentPage === totalPages" (click)="onNext()" class="btn row">
        <span class="material-symbols-outlined">keyboard_arrow_right</span>
    </button>
</div>